import _ from 'lodash'
import React from 'react'

// import combineClassNames from '../../helpers/combineClassNames';
import Modal from '../modal'
import Link from '../link'
import Button from '../button';
import IconInfo from '../../assets/icons/icon_info.svg'

import useStyles from './modal-dialog-style'

const ModalDialog = (props = {}) => {
  const {
    isOpen,
    title,
    infoButton,
    message,
    html,
    contentComponent,
    buttons,
    ...others
  } = props
  const styles = useStyles()
  return (
    <Modal
      dialog
      className={styles.dialogModal}
      overlayClassName={styles.dialogModalOverlay}
      titleClassName={styles.dialogTitle}
      isOpen={isOpen}
      title={title}
      {...others}
    >
      {
        infoButton && (
          <Link
            gatsbyLink
            className={styles.dialogInfoButton}
            {...infoButton}
          >
            <img src={IconInfo} alt="info" className={styles.dialogInfoButtonImage} />
          </Link>
        )
      }
      <div className={styles.dialogContainer}>
        <div className={styles.dialogBody}>
          {
            !_.isEmpty(message) && (
              <p className={styles.dialogDescription}>{message}</p>
            )
          }
          {
            !_.isEmpty(html) && (
              <div
                className={styles.dialogHtml}
                dangerouslySetInnerHTML={{ __html: html }}
              />
            )
          }
          {contentComponent}
          {props.children}
        </div>
        <div className={styles.dialogButtons}>
          {
            _.map(buttons, (button, index) => (
              <Button
                key={`modal_button_${index}`}
                className={styles.button}
                dark={index === 0}
                border={index !== 0}
                {...button}
              />
            ))
          }
        </div>
      </div>
    </Modal>
  )
}

export default ModalDialog
